import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
    Popper,
    Grow,
    ClickAwayListener,
    MenuList,
    Divider,
    MenuItem,
    Menu
} from '@material-ui/core';
import { documentBookCss as useStyles } from '../VehicleCss';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import { getVehicleNumberValuesDWeb } from '../../../../utils/utils';
import { fetchDocumentsBook, DeleteDocument, deletePhotoDocuments, editDocument } from '../../../../store/actions/vehicleActionCreator';
import ErrorIcon from '@material-ui/icons/Error';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AddDocumentDialog from '../../../components/VehicleDialogs/AddDocumentDialog';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { ShareIcon } from '../../../../components/icons'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import CloseIcon from '@material-ui/icons/Close';
import Carousel from 'react-material-ui-carousel'
import S3Uploader from '../../../components/s3Uploader/s3Uploader';
import { DocumentEmptyIcon } from '../../../../components/icons';
import { trackDwebEvent } from "../../../analytics";

const DocumentBook = ({ openBook, onClose, vehicle, dispatchGetDocumentsBook, dispatchEditDocument, dispatchDeleteDocumentsPhoto, dispatchDeleteDocument }) => {

    let submit, formValues;

    const [onOpen, setOnOpen] = useState(null);
    const [documentBookDetails, setDocumentBookDetails] = useState({});
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" })
    const [addDocumentFlag, setAddDocumentFlag] = useState(false);
    const [recall, setRecall] = useState(false);
    const [individualDocumentDetails, setIndividualDocumentDetails] = useState({});
    const [documentEditList, setDocumentEditList] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [docId, setDocId] = useState("");
    const [moreMenu, setMoreMenu] = useState(false);
    const [documentDetailsValue, setDocumentDetailsValue] = useState({});
    const [editFlag, setEditFlag] = useState(false);
    const [renewFlag, setRenewFlag] = useState(false);
    const [documentPdfOpen, setDocumentPdfOpen] = useState(false);
    const [documentDefaultFilterType, setDocumentDefaultFilterType] = useState("");
    const [pdfDocumentFilterList, setPdfDocumentFilterList] = useState([]);
    const [documentDefaultFilterTypeValue, setDocumentDefaultFilterTypeValue] = useState("");
    const [imageCarouselFlag, setImageCarouselFlag] = useState(false);
    const [addPhoto, setAddPhoto] = useState([]);
    const [imageIndex, setImageIndex] = useState(0);
    // const [photoId, setPhotoId] = useState("");
    const [linkView, setLinkView] = useState("");
    const [link, setLink] = useState("");
    const [photoDialog, setPhotoDialog] = useState(false);
    const [deleteIn, setDeleteIn] = useState(false);
    const [otherDocumentFlag, setOtherDocumentFlag] = useState(false);
    const [expiryDateFlag, setExpiryDateFlag] = useState(false);
    const [docData, setDocData] = useState({});

    const classes = useStyles();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    let truck = vehicle && vehicle.singleTruck ? vehicle.singleTruck : "";

    useEffect(() => {

        let data = {
            vehicleId: Number(vehicleId)
        }

        dispatchGetDocumentsBook(data,
            (data) => {
                if (data && data.response && data.response.documents && data.response.documents.length > 0) {
                    logger.log("Document Book Dweb", "Fetch Document Book Successfull ");
                    setOnOpen(true);
                    let list = {};
                    let defaultData = {
                        "all_document": "All Documents"
                    }
                    data.response.documents.forEach(doc => {
                        if (doc && doc.id) {
                            list[doc.documentType] = false;
                            defaultData[doc.documentType] = doc.documentName ? doc.documentName : doc.config && doc.config.name ? doc.config.name : ""
                        }
                    });
                    setDocumentEditList(list);
                    setPdfDocumentFilterList(defaultData);
                }
            },
            () => {
                logger.log("Document Book Dweb", "Fetch Document Book Failed");
            }
        );
    }, [openBook, recall]);

    useEffect(() => {
        if (vehicle.documentsBooks) {
            setDocumentBookDetails(vehicle.documentsBooks);
            const vehicleNumberArray = getVehicleNumberValuesDWeb(vehicle.documentsBooks.vehicleNumber);
            if (vehicleNumberArray && vehicleNumberArray.length > 0) {
                const vehicleNumberSuffixValue = vehicleNumberArray.pop();
                const vehicleNumberPrefixValue = vehicleNumberArray.join("");

                setVehicleNumberType({
                    vehicleNumberPrefix: vehicleNumberPrefixValue,
                    vehicleNumberSuffix: vehicleNumberSuffixValue,
                })
            }

            let expiryArray = vehicle && vehicle.documentsBooks && vehicle.documentsBooks.documents && vehicle.documentsBooks.documents.filter(date => date.expiryDate != null);
            if (expiryArray && expiryArray.length == 0) {
                setExpiryDateFlag(false);
            } else {
                setExpiryDateFlag(true);
            }
        }
    }, [vehicle.documentsBooks]);

    useEffect(() => {

        if (onOpen) {
            trackDwebEvent("Dweb SVP Document Book ", {
                vehicle_id: vehicleId,
                vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : ""
            });
        }

    }, [onOpen])

    const handleAddOtherDocument = () => {
        trackDwebEvent("Dweb SVP Document Create Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : ""
        });
        setAddDocumentFlag(true);
        setOtherDocumentFlag(true);
        setIndividualDocumentDetails(documentBookDetails && documentBookDetails.documents ? documentBookDetails.documents[documentBookDetails.documents.length ? documentBookDetails.documents.length - 1 : ""] : "");
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    const handleCardClick = (details) => {
        if (details.documentType == "Other_Document") {
            setOtherDocumentFlag(true);
        } else {
            setOtherDocumentFlag(false);
        }
        setDocumentDetailsValue({})
        setIndividualDocumentDetails(details);
        setAddDocumentFlag(true);
        setEditFlag(false);
    }

    const handleAddDocumentClose = () => {
        setAddDocumentFlag(false);
        setEditFlag(false);
        setRenewFlag(false);
        setOtherDocumentFlag(false);
    }

    const handleAddDocumentConfirm = () => {
        setAddDocumentFlag(false);
        setRenewFlag(false);
        setEditFlag(false);
        setRecall(!recall);
        setOtherDocumentFlag(false);
    }

    const handleEditDocument = (documentDetails) => {
        trackDwebEvent("Dweb SVP Document Update Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : "",
            document_type: documentDetails && documentDetails.documentType ? documentDetails.documentType : "",
            document_number: documentDetails && documentDetails.documentId ? documentDetails.documentId : "",
            document_expiry: documentDetails && documentDetails.expiryDate ? new Date(documentDetails.expiryDate * 1000) : "",
            count_of_images_uploaded: documentDetails && documentDetails.attachments && documentDetails.attachments.length > 0 ? documentDetails.attachments.length : 0,
            document_id: documentDetails && documentDetails.id ? documentDetails.id : ""
        });
        if (documentDetails && documentDetails.config && documentDetails.config.documentNumberFieldName == "Document No") {
            setOtherDocumentFlag(true);
        }
        // setDocumentDetailsValue(documentDetails);
        setIndividualDocumentDetails(documentDetails);
        setEditFlag(true);
        setAddDocumentFlag(true);
        handleAllDocumentMenuClose();
    }

    const handleAllDocumentMenuClose = () => {
        let cloned = {};
        for (let x in documentEditList) {
            cloned[x] = false;
        }
        setDocumentEditList(cloned);
        setMoreMenu(false);
    }

    const handleDocumentMenu = (docType) => {
        let cloned = { ...documentEditList };
        cloned[docType] = true;
        setDocumentEditList(cloned);
        // setDocumentCardLog(false);
        setMoreMenu(true);
    }

    const handleDeleteDocument = (docDetails) => {
        setDialogOpen(true);
        handleAllDocumentMenuClose();
        setDocData(docDetails);
        setDocId(docDetails.id);
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDocData({});
        setDocId("");
    }

    const onDeleteDocument = () => {

        dispatchDeleteDocument(docId,
            (data) => {
                if (data.status && data.status.code == 200) {
                    trackDwebEvent("Dweb SVP Document Deleted", {
                        vehicle_id: vehicleId,
                        vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : "",
                        document_type: docData && docData.documentType ? docData.documentType : "",
                        document_number: docData && docData.documentId ? docData.documentId : "",
                        document_expiry: docData && docData.expiryDate ? new Date(docData.expiryDate * 1000) : "",
                        count_of_images_uploaded: docData && docData.attachments && docData.attachments.length > 0 ? docData.attachments.length : 0,
                        document_id: docData && docData.id ? docData.id : ""
                    });
                    logger.log("Document Book Dweb", "Delete successfull");
                    setDialogOpen(false);
                    setDocId("");
                    setRecall(!recall);
                }
            },
            () => {
                logger.log("Document Book Dweb", "Delete failed");
            }
        );

    }

    const handleRenew = (docDetails) => {
        setIndividualDocumentDetails(docDetails);
        setAddDocumentFlag(true);
        setRenewFlag(true);
        setEditFlag(false);
        setDocId(docDetails.id);
    }

    const handleRecall = () => {
        setRecall(!recall);
    }

    const handleClosePdf = () => {
        setDocumentPdfOpen(false)
    }

    const handleDocumentPdf = (docDetails, action) => {
        if (action && action == 'share') {
            trackDwebEvent("Dweb SVP Document Shared", {
                vehicle_id: vehicleId,
                vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : "",
                document_type: docDetails && docDetails.documentType ? docDetails.documentType : "",
                document_number: docDetails && docDetails.documentId ? docDetails.documentId : "",
                document_expiry: docDetails && docDetails.expiryDate ? new Date(docDetails.expiryDate * 1000) : "",
                count_of_images_uploaded: docDetails && docDetails.attachments && docDetails.attachments.length > 0 ? docDetails.attachments.length : 0,
                document_id: docDetails && docDetails.id ? docDetails.id : ""
            });
        }
        trackDwebEvent("Dweb SVP Document PDF Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: truck.vehicleNumber ? truck.vehicleNumber : "",
            count_of_document_types: 1
        });
        setDocumentDefaultFilterType(docDetails.documentName);
        setDocumentDefaultFilterTypeValue(docDetails.documentType);
        setDocumentPdfOpen(true);
    }

    const handleDocumentCardClick = (values) => {

        setIndividualDocumentDetails(values);
        setAddPhoto(values && values.attachments ? values.attachments : []);
        setImageCarouselFlag(true);
    }

    const handleCourselClose = () => {
        setImageCarouselFlag(false);
        setImageIndex(0);
        setIndividualDocumentDetails({});
    }

    function Item(props) {
        // setPhotoId(props.item.id);
        setLinkView(props.item.s3Link)
        if (typeof (props.item != 'object')) {
            setLink(props.item);
        }

        return (
            <Paper className={classes.paperItem}>
                <img src={props.item.s3Link || props.item} alt="fileUpload" className={classes.imgV2} />
            </Paper>
        )
    }

    const handlePhotoClose = () => {
        setPhotoDialog(false);
    }

    const handlePhotoModal = () => {
        setPhotoDialog(true);
    }

    const handleAddPhoto = (file) => {

        var newPhoto = [...addPhoto];
        newPhoto.push({ s3Link: file });
        setAddPhoto(newPhoto);

        var data = {
            vehicleId: vehicleId ? Number(vehicleId) : "",
            documents: {
                documentEntityType: individualDocumentDetails && individualDocumentDetails.documentEntityType ? individualDocumentDetails.documentEntityType : "",
                documentId: individualDocumentDetails && individualDocumentDetails.documentId ? individualDocumentDetails.documentId : "",
                documentType: individualDocumentDetails && individualDocumentDetails.documentType ? individualDocumentDetails.documentType : "",
                documentName: individualDocumentDetails && individualDocumentDetails.documentName ? individualDocumentDetails.documentName : "",
                expiryDate: individualDocumentDetails && individualDocumentDetails.expiryDate ? individualDocumentDetails.expiryDate : "",
                id: individualDocumentDetails && individualDocumentDetails.id ? individualDocumentDetails.id : "",
                isReminderEnabled: individualDocumentDetails && individualDocumentDetails.isReminderEnabled ? 1 : 0,
                reminderDuration: individualDocumentDetails && individualDocumentDetails.reminderDuration ? Number(individualDocumentDetails.reminderDuration) : "",
                reminderDurationUnit: individualDocumentDetails && individualDocumentDetails.reminderDurationUnit ? individualDocumentDetails.reminderDurationUnit : "",
                attachments: newPhoto
            }
        }

        if (individualDocumentDetails && individualDocumentDetails.amount) {
            data.documents.amount = individualDocumentDetails.amount
        }

        if (individualDocumentDetails && individualDocumentDetails.expenseDate) {
            data.documents.expenseDate = individualDocumentDetails.expenseDate
        }

        dispatchEditDocument(data,
            (data) => {
                logger.log("Document Book Dweb", "Edit document Successfull")
                if (data && data.status.code && data.status.code == 200) {
                    setRecall(!recall);
                    setImageIndex(Number(newPhoto.length) - 1);
                }
            },
            () => {
                logger.log("Document Book Dweb", "Edit Document Failed");
            }
        );

    }

    const handleImage = (index) => {
        setImageIndex(index);
    }

    const handleDeleteInPhotoDialog = () => {
        setDeleteIn(true);
    }

    const handleDeleteInPhotoDialogClose = () => {
        setDeleteIn(false);
    }

    const onDeleteInPhotoDialog = () => {

        setDeleteIn(false);
        var newPhoto = addPhoto;
        var index = addPhoto.findIndex(x => x.s3Link === link.s3Link);

        var imageId = (index == 0 || index > 0) && newPhoto[index] ? newPhoto[index].id : "";

        newPhoto.splice(index, 1);
        setAddPhoto(newPhoto);

        if (imageId) {
            dispatchDeleteDocumentsPhoto(
                individualDocumentDetails.id,
                imageId,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Document Book Dweb", "Attachment deleted successfully");
                        setRecall(!recall);
                    }
                },
                () => {
                    logger.log("Document Book Dweb", "Attachment delete failed");
                },
            )
        }
    };

    const handleAddPhotoFromCard = (file) => {
        var newPhoto = [];
        newPhoto.push({ s3Link: file });

        var data = {
            vehicleId: vehicleId ? Number(vehicleId) : "",
            documents: {
                documentEntityType: individualDocumentDetails && individualDocumentDetails.documentEntityType ? individualDocumentDetails.documentEntityType : "",
                documentId: individualDocumentDetails && individualDocumentDetails.documentId ? individualDocumentDetails.documentId : "",
                documentType: individualDocumentDetails && individualDocumentDetails.documentType ? individualDocumentDetails.documentType : "",
                documentName: individualDocumentDetails && individualDocumentDetails.documentName ? individualDocumentDetails.documentName : "",
                expiryDate: individualDocumentDetails && individualDocumentDetails.expiryDate ? individualDocumentDetails.expiryDate : "",
                id: individualDocumentDetails && individualDocumentDetails.id ? individualDocumentDetails.id : "",
                isReminderEnabled: individualDocumentDetails && individualDocumentDetails.isReminderEnabled ? 1 : 0,
                reminderDuration: individualDocumentDetails && individualDocumentDetails.reminderDuration ? Number(individualDocumentDetails.reminderDuration) : "",
                reminderDurationUnit: individualDocumentDetails && individualDocumentDetails.reminderDurationUnit ? individualDocumentDetails.reminderDurationUnit : "",
                attachments: newPhoto
            }
        }

        if (individualDocumentDetails.amount) {
            data.documents.amount = individualDocumentDetails.amount
        }

        if (individualDocumentDetails.expenseDate) {
            data.documents.expenseDate = individualDocumentDetails.expenseDate
        }

        dispatchEditDocument(data,
            (data) => {
                logger.log("Document Book Dweb", "Edit document Successfull")
                if (data && data.status.code && data.status.code == 200) {
                    setRecall(!recall);
                }
            },
            () => {
                logger.log("Document Book Dweb", "Edit Document Failed");
            }
        );
    }

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="document-book"
                rightSideBarOpen={onOpen}
                sideBarTitle={'Document Book'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={documentBookDetails && documentBookDetails.vehicleBodyType ? documentBookDetails.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                addExpense={handleAddOtherDocument}
                toggleRightSideBar={onConfirm}>


                {documentBookDetails && documentBookDetails.alert &&
                    <div className={documentBookDetails.totalCount == 0 || !expiryDateFlag ? classes.divAlertEmpty : classes.divAlert}>
                        <ErrorIcon className={documentBookDetails.totalCount == 0 || !expiryDateFlag ? classes.errorIconEmpty : classes.errorIcon} />
                        <div className={classes.alertText}>
                            {documentBookDetails.alert}
                        </div>
                    </div>
                }

                <div className={documentBookDetails && documentBookDetails.alert ? classes.mtV1 : ""}>
                    {documentBookDetails && documentBookDetails.documents && documentBookDetails.documents.map((document) => (
                        <>
                            {document && document.id &&
                                < Card className={classes.cardV1} onClick={() => document.attachments && document.attachments[0] ? handleDocumentCardClick(document) : ""}>
                                    <CardContent className={classes.cardContentV2}>
                                        <div className={classes.dFlex}>
                                            <div className={classes.widthV1}>
                                                <div className={classes.divThumbNail}>
                                                    {document && document.attachments[0] && document.attachments[0].s3Link &&
                                                        <img src={document.attachments[0] && document.attachments[0].s3Link ? document.attachments[0].s3Link : ""} className={classes.imgV1} />
                                                    }
                                                </div>

                                                {!document.attachments[0] &&
                                                    <div onClick={(e) => {
                                                        setIndividualDocumentDetails(document)
                                                        e.stopPropagation()
                                                    }}
                                                    >
                                                        <S3Uploader directoryName={"dweb-images/Vehicle/DocumentBook"} fromDocumentBook={true} handleFile={handleAddPhotoFromCard} id={document.config && document.config.value ? document.config.value : ""}
                                                            className={classes.mlV4} />
                                                    </div>
                                                }
                                            </div>

                                            <div className={classes.mlV1} style={{ width: "85%" }} onClick={e => !document.attachments[0] ? e.stopPropagation() : ""}>
                                                <div className={classes.fw300}>{document.documentName}</div>
                                                {document.documentId &&
                                                    <div className={classes.divDocumentId}>{document.documentId}</div>
                                                }
                                                <div>
                                                    {document.status == 'Expired' &&
                                                        <div> <span className={classes.alertDanger}> {document.expiryAlert ? document.expiryAlert : ""}</span></div>
                                                    }
                                                    {document.status == 'Expiring' &&
                                                        <div><span className={classes.alertDanger1}> {document.expiryAlert ? document.expiryAlert : ""}</span></div>
                                                    }
                                                    {document.status == 'Active' &&
                                                        <div> <span className={classes.alertDanger2}> {document.expiryAlert ? document.expiryAlert : ""}</span></div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={classes.mtV3}>
                                                <IconButton
                                                    aria-label="display more actions"
                                                    edge="end"
                                                    color="inherit"
                                                    onClick={(e) => {
                                                        handleDocumentPdf(document);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <PictureAsPdfIcon className={classes.pdfIcon} />
                                                </IconButton>
                                                <IconButton
                                                    aria-haspopup="true"
                                                    onClick={(e) => {
                                                        handleDocumentMenu(document.documentType)
                                                        e.stopPropagation();

                                                    }}
                                                    aria-label="settings" className={classes.docActions}
                                                >
                                                    <MoreVertIcon className={classes.moreIcon} />
                                                </IconButton>

                                                {documentEditList && documentEditList[document.documentType] && <div className={classes.singleVehicleMenu}><Paper className={classes.singleVehicleMenuPaper}>
                                                    <ClickAwayListener onClickAway={(e) => {
                                                        handleAllDocumentMenuClose()
                                                        e.stopPropagation()
                                                    }}>
                                                        <MenuList id="menu-list-grow" >
                                                            <MenuItem onClick={(e) => {
                                                                handleEditDocument(document)
                                                                e.stopPropagation()
                                                            }} className={classes.fw300}><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;Edit Document</MenuItem>
                                                            <MenuItem className={classes.fw300} onClick={(e) => {
                                                                handleDocumentPdf(document, 'share');
                                                                e.stopPropagation()
                                                            }}><ShareIcon className={classes.shareIcon} /><span>Share</span></MenuItem>
                                                            <MenuItem className={classes.deleteMenu} onClick={(e) => {
                                                                handleDeleteDocument(document)
                                                                e.stopPropagation()
                                                            }} ><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;Delete</MenuItem>
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper></div>}
                                            </div>
                                            <div className={classes.divRenew} onClick={(e) => {
                                                handleRenew(document)
                                                e.stopPropagation();
                                            }}>
                                                {document.isRenew && <span className={classes.renewAction}>Renew <ArrowForwardIosIcon className={classes.renewForward} /></span>}
                                            </div>

                                        </div>
                                    </CardContent>
                                </Card>
                            }
                            {document && !document.id &&
                                < Card className={classes.cardV1} onClick={() => handleCardClick(document)}>
                                    <CardContent className={classes.cardContentV1}>
                                        <div>
                                            <div className={classes.divIcon}>
                                                <AddAPhotoIcon className={classes.colorV1} />
                                            </div>
                                        </div>
                                        <div className={classes.mlV1}>
                                            <div className={classes.fw300}>{document.config && document.config.name ? document.config.name : ""}</div>
                                            <div className={classes.divAddExpiry}>Add Expiry</div>
                                        </div>
                                    </CardContent>
                                </Card>
                            }
                        </>
                    ))}
                </div>

            </RightSideBar>}

            {/* Document Delete. */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divDelete}>Delete </div>
                    <div className={classes.mtV4}>Are you sure you want to delete ?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteDocument}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Image Coursel. */}
            <Dialog fullWidth={true}
                maxWidth='xl'
                onClose={handleCourselClose} disableEscapeKeyDown={true} disableBackdropClick={true} open={imageCarouselFlag} classes={{ paperScrollPaper: classes.paper1, paperWidthXl: classes.paperWidth }} >
                <DialogTitle id="add-party-dialog-title" className={classes.dialogTitleV1}>
                    <div>
                        {individualDocumentDetails && individualDocumentDetails.config && individualDocumentDetails.config.name ? individualDocumentDetails.config.name : ""}
                    </div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleCourselClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <>
                        {addPhoto && addPhoto.length == 0 &&
                            <>
                                <div className={classes.divImageEmpty}>
                                    <DocumentEmptyIcon className={classes.documnetEmptyIcon}></DocumentEmptyIcon>
                                    <div className={classes.divEmptyText}>Manage your vehicle documents Challan <div> by uploading here </div></div>
                                    <div className={classes.mtV5}>
                                        <S3Uploader directoryName={"dweb-images/Vehicle/DocumentBook"} toggle={true} handleFile={handleAddPhoto} />
                                    </div>
                                </div>
                            </>
                        }

                        {addPhoto && addPhoto.length > 0 &&
                            <>
                                <Grid
                                    container
                                    // spacing={1}
                                    direction="row"
                                    justify="flex-start"
                                    alignItems="center"
                                    className={classes.mtV5}
                                >

                                    <Grid item>
                                        <div className={classes.S3UploaderImageMargin}>
                                            {addPhoto.length > 0 && addPhoto.map((imgValue, index) => (
                                                <div className={classes.S3UploaderImageDiv} onClick={() => handleImage(index)}>
                                                    {(typeof (imgValue) != 'object') && <img className={index == imageIndex ? classes.S3UploaderImageSrcActive : classes.S3UploaderImageSrc} src={imgValue} alt="fileUpload" />}
                                                    {imgValue.s3Link && <img className={index == imageIndex ? classes.S3UploaderImageSrcActive : classes.S3UploaderImageSrc} src={imgValue.s3Link} alt="fileUpload" />}
                                                </div>
                                            ))}
                                        </div>
                                    </Grid>
                                    <Grid item >
                                        <S3Uploader directoryName={"dweb-images/Vehicle/DocumentBook"} handleFile={handleAddPhoto} className={classes.mlV3} fromDocumentBookImage={true} />
                                    </Grid>
                                </Grid>

                                <Carousel
                                    indicators={false}
                                    navButtonsAlwaysVisible={true}
                                    index={imageIndex}
                                    animation="slide"
                                    autoPlay={false}
                                    next={(next, active) => logger.log("Document Book", `we left ${active}, and are now at ${next}`)}
                                    prev={(prev, active) => logger.log("Document Book", `we left ${active}, and are now at ${prev}`)}
                                >
                                    {
                                        addPhoto.map((item, i) => <Item key={i} item={item} />)
                                    }
                                </Carousel>

                                <div className={classes.divV10}>
                                    <div>
                                        <div className={classes.fzV1}>{individualDocumentDetails.documentId}</div>
                                        {individualDocumentDetails.status == 'Expired' &&
                                            <div className={classes.alertDanger} style={{ marginTop: '6px' }}> {individualDocumentDetails.expiryAlert ? individualDocumentDetails.expiryAlert : ""}</div>
                                        }
                                        {individualDocumentDetails.status == 'Expiring' &&
                                            <div className={classes.alertDanger1} style={{ marginTop: '6px' }}> {individualDocumentDetails.expiryAlert ? individualDocumentDetails.expiryAlert : ""}</div>
                                        }
                                        {individualDocumentDetails.status == 'Active' &&
                                            <div className={classes.alertDanger2} style={{ marginTop: '6px' }}> {individualDocumentDetails.expiryAlert ? individualDocumentDetails.expiryAlert : ""}</div>
                                        }
                                    </div>
                                    <div className={classes.cursorPointer} onClick={() => handleDeleteInPhotoDialog()}>
                                        <DeleteOutlineOutlinedIcon className={classes.deleteIconV1} />
                                    </div>
                                </div>
                            </>
                        }
                    </>
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={handleCourselClose} >
                        Close
                    </Button>

                    {addPhoto && addPhoto.length > 0 &&
                        <Button className={classes.confirmV1} type="submit" variant="contained" onClick={() => handlePhotoModal()}>
                            View
                        </Button>
                    }
                </DialogActions>
            </Dialog>

            {/* View image dialog. */}
            <Dialog open={photoDialog} onClose={handlePhotoClose} maxWidth="lg">
                <span className={classes.taEnd}><CloseIcon onClick={handlePhotoClose} className={classes.cursorPointer} /></span>
                <img src={linkView} alt="fileUpload" sizes="small" className={classes.mWV1} />
            </Dialog>

            {/* Delete image confirmation dialog from image coursel. */}
            <Dialog
                maxWidth="lg"
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteIn} onClose={handleDeleteInPhotoDialogClose} classes={{ paperWidthLg: classes.paperWidthV1 }}
            >
                <DialogContent>
                    <div className={classes.mtV4}>Are you sure you want to delete ?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteInPhotoDialogClose}>
                        <span className={classes.divNo}>
                            NO
                        </span>
                    </Button>
                    <Button onClick={onDeleteInPhotoDialog}>
                        <span className={classes.divYes}>
                            YES
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            { addDocumentFlag && <AddDocumentDialog open={addDocumentFlag} onClose={handleAddDocumentClose} onConfirm={handleAddDocumentConfirm} individualDocument={individualDocumentDetails} edit={editFlag} callRecall={handleRecall} renew={renewFlag} docIdValue={docId} otherDocumentFlagValue={otherDocumentFlag} />}
            {
                documentPdfOpen &&
                <ReportsDialog open={documentPdfOpen} name={"Document Book"} vehicleNumberValue={vehicleNumberType} truckType={documentBookDetails && documentBookDetails.vehicleBodyType ? documentBookDetails.vehicleBodyType : ""} onClose={handleClosePdf} fromDocumentBook={true} vehicleIdValue={vehicleId} pdfFilterValue={pdfDocumentFilterList} defaultDocumentFilterValueName={documentDefaultFilterType} defaultDocumentFilterValueType={documentDefaultFilterTypeValue} />
            }
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteDocument: (documentId, onSuccess, onFailure) => dispatch(DeleteDocument(documentId, onSuccess, onFailure)),
    dispatchGetDocumentsBook: (data, onSuccess, onFailure) => { dispatch(fetchDocumentsBook(data, onSuccess, onFailure)) },
    dispatchDeleteDocumentsPhoto: (documentId, attachId, onSuccess, onFailure) => dispatch(deletePhotoDocuments(documentId, attachId, onSuccess, onFailure)),
    dispatchEditDocument: (data, onSuccess, onFailure) => dispatch(editDocument(data, onSuccess, onFailure)),

});

export default (connect)(mapStateToProps, mapDispatchToProps)(DocumentBook);
